import { render, staticRenderFns } from "./FormInputField.vue?vue&type=template&id=dbebfa36&scoped=true&"
import script from "./FormInputField.vue?vue&type=script&lang=ts&"
export * from "./FormInputField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbebfa36",
  null
  
)

export default component.exports